import { forwardRef } from 'react';

interface Option {
  value: string;
  label: string;
}

interface RadioGroupProps {
  label: string;
  options: Option[];
  value?: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  required?: boolean;
  name: string;
}

export const RadioGroup = forwardRef<HTMLFieldSetElement, RadioGroupProps>(
  ({ label, options, value, onChange, error, helperText, required, name }, ref) => {
    return (
      <fieldset ref={ref} className="field-group border-0 p-0 m-0 min-w-0">
        <legend className="form-label w-full">
          {label}
          {required && <span className="form-label-required">*</span>}
        </legend>

        <div className="space-y-2">
          {options.map((option) => (
            <label
              key={option.value}
              className="flex items-center cursor-pointer gap-3 p-2 rounded-md group hover:bg-neutral-100 transition-colors duration-200"
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={(e) => onChange(e.target.value)}
                className="w-4 h-4 text-primary-600 border-neutral-300 focus:ring-primary-500 cursor-pointer transition-all"
                aria-invalid={!!error}
              />
              <span className="text-sm text-neutral-700 group-hover:text-neutral-900 font-medium transition-colors">
                {option.label}
              </span>
            </label>
          ))}
        </div>

        {error && <p className="error-message">{error}</p>}

        {!error && helperText && <p className="helper-text">{helperText}</p>}
      </fieldset>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';